import React from 'react';
import { Alert, Box, Button, Stack, Typography } from '@mui/material';
import { Edit } from '@mui/icons-material';

export default function PaymentNotesSection({ notes = [], onEditNotes }) {
  const list = Array.isArray(notes) ? notes.filter(Boolean) : [notes].filter(Boolean);

  return (
    <Stack spacing={1.5}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
          Notas
        </Typography>
        {onEditNotes && (
          <Button size="small" startIcon={<Edit />} onClick={onEditNotes}>
            Editar
          </Button>
        )}
      </Stack>

      {list.length === 0 ? (
        <Alert severity="info">Sin notas registradas.</Alert>
      ) : (
        <Stack spacing={1}>
          {list.map((note, index) => (
            <Box
              key={`${note}-${index}`}
              sx={{
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 1,
                p: 1.5,
                bgcolor: 'background.paper',
              }}
            >
              <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
                {note}
              </Typography>
            </Box>
          ))}
        </Stack>
      )}
    </Stack>
  );
}
